import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 7L7.64645 2.35355C7.84171 2.15829 8.15829 2.15829 8.35355 2.35355L13 7M14 14.5H2M8 2.5V12",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgExport;
